import { useTheme, useMediaQuery, Card, CardContent, Stack, Link, Accordion, AccordionDetails, AccordionSummary, Box, Typography, Alert, List, ListSubheader, ListItem, Table, TableContainer, Paper, TableHead, TableBody, TableRow, TableCell, TableFooter } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ElectionSchedulesCalculator from '../../../../Municipal/components/ElectionSchedulesCalculator';

const MunicipalCandidate = (): JSX.Element => {

  const theme = useTheme();
  const isSM = useMediaQuery(theme.breakpoints.down('sm'));

  const data = [
    {
      title: "Candidates and Committees in Towns ",
      requirements: [
        { type: "Pre-Preliminary (if held)", dueDate: "8 days before preliminary" },
        { type: "Pre-Election", dueDate: "8 days before election" },
        { type: "Post-Election", dueDate: "30 days after election" },
        { type: "Year-End", dueDate: "January 20th of following year" }
      ],
      footnotes:
        [
          "The Year-end repor is only required for incumbents, candidates/committees with continuing balances or liabilities, or those that did not dissolve in post-election report or prior to December 31 of the preceding year.",
        ]
    },
    {
      title: "Candidates and Committees in Cities",
      requirements: [
        { type: "Pre-Preliminary", dueDate: "8 days before preliminary" },
        { type: "Pre-Election", dueDate: "8 days before election" },
        { type: "Year-End", dueDate: "January 20th of following year" }
      ],
      footnotes: ["In off-election years, the year-end report is only required for incumbents, candidates/committees with continuing balances or liabilities, or those that did not disolve prior to December 31 of the preceding year.",]
    }


  ];


  return (
    <Box>
      <Alert severity="warning" >
        Candidates for City Councillor in cities with populations of 65,000 or more (<i>Boston, Brockton, Cambridge, Fall River, Framingham, Haverhill, Lawrence, Lowell, Lynn, Malden, New Bedford, Newton, Quincy, Somerville, Springfield, Waltham, Worcester</i>) and all mayoral candidates click on the <b>Non-Legislative Candidates</b> tab to view the filing schedule for these candidates.
      </Alert>
      <Typography variant="h6" gutterBottom fontWeight={600} marginTop={3}>
        Local Candidates and Committees
      </Typography>
      <Typography variant="body1" component={'p'} gutterBottom>
        Local candidates and committees refer to anyone who do not file with OCPF, including candidates for municipal office, municipal ballot question committees, municipal political action committees, and Barnstable Assembly of Delegates. Local candidates file reports with election officials in their respective cities and towns, following the local election calendar.
      </Typography>
      <Typography variant="body1" component={'p'} gutterBottom>
        Click <Link underline="none" href="https://ocpfreporter.us/LocalFilerSignup" target="_blank">here</Link> to use OCPF's reporting software, Reporter 7, to create and print campaign finance reports to file with your local election official(s).
      </Typography>

      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={'bold'} variant={'subtitle1'}>Report Filing Schedule</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Alert severity="info" >The town schedule applies to the vast majority of towns that hold their annual elections in the late winter or spring. Towns that hold their annual elections in November follow the city schedule.
            The filing schedules can also be calculated using <Link underline="none" href="#election-calculator">OCPF's Election Calculator</Link>.
          </Alert>

          {!isSM ? data.map((item, index) => (
            <Box key={index}>
              <Typography variant="body2" marginTop={5} marginBottom={1} fontWeight={550}><u>{item.title}</u></Typography>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="reporting requirements table">
                  <TableHead>
                    <TableRow key={item.title + '-head' + index}>
                      <TableCell><b>Report Type</b></TableCell>
                      <TableCell><b>Due Date</b></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {item.requirements.map((row, index) => (
                      <TableRow
                        key={row.type + index + row.dueDate}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell>
                          <Typography variant='body2' color="primary">
                            {row.type}
                          </Typography>
                        </TableCell>
                        <TableCell>{row.dueDate}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableFooter>
                    {item.footnotes.map((footnote, index) => (
                      <TableRow key={index + '-footnote'}>
                        <TableCell colSpan={2}>
                          <Typography variant="caption" color="text.secondary">{footnote}</Typography>
                        </TableCell>
                      </TableRow>
                    ))}

                  </TableFooter>
                </Table>
              </TableContainer>
            </Box>
          ))

            :
            /*mobile view*/

            data.map((item, index) => (
              <Box key={index}>
                <Typography variant="body2" marginTop={5} marginBottom={1} fontWeight={550}><u>{item.title}</u></Typography>
                {item.requirements.map((row, index) => (
                  <Card variant="outlined" key={index} sx={{ marginBottom: 2 }}>
                    <CardContent>
                      <Stack spacing={1}>
                        <Typography variant="body2">
                          <b>Report Type: </b>{row.type}
                        </Typography>
                        <Typography variant="body2">
                          <b>Due Date: </b>{row.dueDate}
                        </Typography>
                      </Stack>
                    </CardContent>
                  </Card>
                ))}
                <Typography variant="caption" color="text.secondary" marginTop={1} marginBottom={1}>
                  {item.footnotes.map((footnote, index) => (
                    <span key={index + '-footnote'}>
                      *{footnote}
                    </span>
                  ))}
                </Typography>
              </Box>
            ))


          }



        </AccordionDetails>
      </Accordion>
      <Box marginTop={4} id="election-calculator">
        <Typography variant="body1" component={'p'} gutterBottom marginTop={4} fontWeight={550} color="primary">
          Local Filers and Clerks can also use the calculator below to determine due dates and reporting periods for locally-filed reports.
        </Typography>
        <ElectionSchedulesCalculator></ElectionSchedulesCalculator>
      </Box>
    </Box>
  )
};

export default MunicipalCandidate;